module.exports = __webpack_public_path__ + "static/media/qr_com.9b178210.jpg";